/**
 * Клавиши, которыми пользователь переходит с элемента на элемент.
 *
 * Только они означают переход: `Escape`, `Enter` и пробел фокус не переносят — окно, закрытое
 * ими, возвращает фокус на свою кнопку само, и это уже не переход пользователя.
 */
const NAVIGATION_KEYS = new Set([
  'Tab',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
]);

/** Последнее действие пользователя — нажатие клавиши перехода */
let isNavigationKeyPressed = false;

let isTracking = false;

/**
 * Начать различать переход пользователя по клавиатуре и фокус, поставленный самим интерфейсом.
 *
 * Признака «кто поставил фокус» в событии фокуса нет, а `:focus-visible` его не заменяет: фокус,
 * возвращённый окном после закрытия с клавиатуры, браузер тоже считает клавиатурным. Отличает их
 * только то, что предшествовало фокусу, — поэтому нажатия отслеживаются глобально.
 *
 * Вызов идемпотентен, слушатели живут всё время работы приложения: состояние общее на интерфейс,
 * а не на отдельный элемент.
 */
export const trackKeyboardNavigation = (): void => {
  if (isTracking) return;
  isTracking = true;

  document.addEventListener(
    'keydown',
    (event) => {
      isNavigationKeyPressed = NAVIGATION_KEYS.has(event.key);
    },
    true,
  );
  document.addEventListener(
    'pointerdown',
    () => {
      isNavigationKeyPressed = false;
    },
    true,
  );
};

/**
 * Текущий фокус получен переходом пользователя по клавиатуре, а не поставлен интерфейсом.
 *
 * Проверять имеет смысл только в обработчике фокуса: браузер переносит фокус сразу за нажатием,
 * поэтому в этот момент последнее нажатие и есть причина фокуса.
 */
export const isKeyboardNavigationFocus = (): boolean => isNavigationKeyPressed;
